import {
  faDownload,
  faEllipsisVertical,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useEffect, useState } from "react";
import { Button, Dropdown, Form, Modal, Nav, Spinner } from "react-bootstrap";
import useLocalStorageState from "use-local-storage-state";
import { useGetRequest, usePostRequest } from "../../Utils/hooks/QueryHandler";
import { toast } from "sonner";
import { imageURL } from "../../Utils/constants/constant";
import pdfIcon from "../../Utils/assets/img/icons/pdf_Icon.webp";
import image_document_icon from '../../Utils/assets/img/icons/image_document_icon.png'
import { DeleteRequest } from "../../Utils/hooks/ApiHandler";
import DeleteModal from "../DeleteModal";
import nodata from "../../Utils/assets/img/leads_no_data_found.png"
import { handleDownloadFile } from "../../Utils/helpers/commonhelper";
import { UnauthViewModal } from "../../CommonComponents/UnauthViewModal";
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials";


// Zod schema
const documentSchema = z.object({
  name: z.string().nonempty("Name is required"),
  file: z
    .any()
    .refine((files) => {
      if (!files || files.length === 0) return false;
      const file = files[0];
      const allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/jpg"];
      return allowedTypes.includes(file.type);
    }, {
      message: "Only PDF, JPG, JPEG,  and PNG files are allowed",
    }),
  description: z.string().nonempty("Description is required"),
});
const DocumentsList = ({
  id,
  moduleType,
  // show,
  docGrant,
  // onDelete,
  // documentData,
  // documents,
  // fetchDocument,
  // setDocuments,
  // documentToDelete,
  // setDocumentToDelete,
}) => {

  // Session storage and authentication setup
  const { customer, setCustomer, headers, extras, navigate, customerId, loginUserId, userType } = useGetEssentials()

  const [showModal, setShowModal] = useState(false)
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [documentToDelete, setDocumentToDelete] = useState(null);
  const [moduleName, setModuleName] = useState(moduleType || "")
  const [submitLoading, setSubmitLoading] = useState(false) // New state for submit loader

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({ resolver: zodResolver(documentSchema) });

  const onClose = () => {
    setShowModal(false)
    reset()
  }

  //  Dynamic API URL for fetch
  const apiUrl =
    moduleType === "Company"
      ? `company/fetchDocuments/${customerId}/${id}/${loginUserId}`
      : moduleType === "project"
        ? `project/fetchDocuments/${customerId}/${id}/${loginUserId}`
        : `contacts/fetchDocuments/${customerId}/${id}/${loginUserId}`;

  const {
    data: documentData,
    error,
    refetch: fetchDocument,
    isError,
    isLoading
  } = useGetRequest(apiUrl, "getDocument", headers, extras);

  // // Update documents
  useEffect(() => {
    if (documentData?.status === "success") {
      setDocuments(documentData?.data);
    } else if (isError) {
      console.error("Error fetching documents:", error);
    }
  }, [documentData, isError, error]);

  // Update module name on prop change
  useEffect(() => {
    setModuleName(moduleType);
    fetchDocument();
  }, [moduleType, id]);


  //  Dynamic upload API
  const { mutate: addDocument } = usePostRequest(
    `${moduleType.toLowerCase()}/uploadDocument/`,
    true,
    { headers },
    extras
  );


  // Form submit
  const onSubmit = async (formData) => {
    const file = formData.file?.[0];
    const payload = {

      [moduleType.toLowerCase() === "contacts"
        ? "contact_id"
        : moduleType.toLowerCase() === "project"
          ? "project_id"
          : "company_id"]: id,

      document: file,
      user_login_id: loginUserId,
      description: formData.description,
      document_name: formData.name,
    };

    setSubmitLoading(true); // Start loader

    try {
      setLoading(true);
      addDocument(payload, {
        onSuccess: (res) => {
          if (res.status === "success") {
            toast.success(res.message || "Document added successfully");
            fetchDocument();
            reset();
            setShowModal(false);
          } else {
            toast.error(res.message || "Failed to add document");
          }
        },
        onError: (err) => {
          toast.error(err?.message || "Add document request failed");
        },
        onSettled: () => {
          setSubmitLoading(false); // Stop loader whether success or error
        },
      });
    } catch (err) {
      console.error("Error submitting document", err);
    } finally {
      setLoading(false);
    }
  };

  // Helper to check if form is submitting
  const isFormSubmitting = submitLoading || isSubmitting;
  // Helpers
  const handleOpenFile = (fileUrl) => {
    if (fileUrl) {
      window.open(fileUrl, "_blank");
    } else {
      alert("No file URL found.");
    }
  };

  const formatedDate = (dates) => {
    const date = new Date(dates);
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }).format(date);
  };

  const formatedTime = (times) => {
    const Time = new Date(times);
    return new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(Time);
  };

  // const downloadPDF = async (fileUrl) => {
  //   const baseUrl = `${imageURL}${fileUrl}`;

  //   try {
  //     const response = await fetch(baseUrl, { method: "GET" });
  //     if (!response.ok) throw new Error("Network response was not ok");

  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = baseUrl.split("/").pop(); // filename
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);

  //     window.URL.revokeObjectURL(url); // cleanup
  //   } catch (error) {
  //     console.error("Download failed:", error);
  //   }
  // };

  // Trigger delete modal
  const onDelete = (id) => {
    setDocumentToDelete(id);
    setShowDeleteModal(true);
  };


  const handleConfirmedDelete = async () => {
    try {

      const item = documents.find((doc) => doc.id === documentToDelete);

      if (!item) return toast.error("no record find to delete");

      const res = await DeleteRequest(
        `/${moduleType}/DeleteDocuments/${id}/${documentToDelete}/${customerId}/${loginUserId}`,
        { headers },
        extras
      );


      if (res.status !== "success" || res.status === "fail") {
        return toast.error(res.message || "Failed to delete document");
      }

      if (res.status === "success") {
        toast.success(res.message || "document deleted successfully");
        setDocuments((prevDocs) =>
          prevDocs.filter((doc) => doc.id !== documentToDelete)
        );
        await fetchDocument();
      }
    } catch (error) {
      console.error("Delete error", error)
    } finally {
      setShowDeleteModal(false);
      setDocumentToDelete(null);
    }
  };

  return (
    < >
      <div className="d-flex justify-content-between align-items-center px-3">
        <div style={{ fontSize: "19px", lineHeight: 1.3, fontWeight: 300 }}
          className="mb-0">
          {" "}
          {moduleName === "Company" ? moduleName : ""} Documents
        </div>

        <button
          className="btn btn-default-outline"
          style={{
            fontSize: "13px",
            height: "30px",
            width: "auto",
            gap: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "2px",
            color: "#fff"
          }}
          onClick={() => {
            if (!docGrant?.isCreate) {
              toast.warning("You are not authorized for this action!")
              return
            }
            setShowModal(true)
          }}
        >
          <FontAwesomeIcon icon={faPlus} /> Add
        </button>
      </div>
      <hr className="mb-0" style={{ marginTop: "11px" }} />

      {/* Documents list */}
      <div className="listStyleForContact" style={{
        height: "calc(100vh - 13rem)",
        overflowY: "auto",
        overflowX: "hidden",
        scrollBehavior: "smooth",
        scrollbarWidth: "thin"
      }}
        onMouseEnter={(e) => {
          e.currentTarget.style.scrollbarColor = "#e0e0e0 white"
        }}
      >
        {
          docGrant?.isView ?
            documents?.length > 0 ? (
              <>
                {documents.map((d) => (
                  <div
                    key={d.id}
                    className="d-flex gap-2 align-items-start justify-content-between px-3 py-3"
                    style={{
                      borderBottom: "1px solid lightblue",
                      borderLeft: "none",
                      borderRight: "none",
                    }}
                  >
                    <div className="d-flex gap-2">
                      <div
                        onClick={() => {
                          handleOpenFile(`${imageURL}${d.document}`);
                        }}
                        style={{ cursor: "pointer" }}
                        className="d-flex align-items-start pt-1 me-2"
                      >
                        <img src={d.document.split(".").pop() === "pdf" ? pdfIcon : image_document_icon} alt="" style={{ width: 50, borderRadius: "5px" }} />
                      </div>
                      <div>
                        <p
                          className="mb-0 fs-14"
                          style={{ color: "black", fontWeight: 500 }}
                        >
                          {d.document_name}
                        </p>
                        <p className="mt-0 mb-0 fs-12">{d.description}</p>
                        <div className="mt-0 d-flex" style={{ gap: 4, color: "rgb(0, 153, 255)" }}>
                          <span className="fs-11 mb-0">
                            Uploaded on : {formatedDate(d.created_at)}
                          </span>
                          <span className="fs-11 mb-0">
                            at {formatedTime(d.created_at)}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div>
                      <Dropdown as="div" className="dropdownsWithoutToggle">
                        <Dropdown.Toggle as={Nav.Link} className="dropdownTogglesBtns ms-3">
                          <FontAwesomeIcon
                            style={{
                              width: "15px",
                              height: "15px",
                            }}
                            icon={faEllipsisVertical}
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          className="defaultDropdown dropdown-menu-end"
                          style={{
                            width: "11rem",
                            padding: "12px 0px",
                            right: "3.4rem",
                          }}
                        >
                          <Dropdown.Item
                            href="#"
                            className="d-flex align-items-center"
                            onClick={() => {
                              if (!docGrant.isView) {
                                toast.warning("You are not authorized for this action!")
                                return
                              }
                              handleDownloadFile({ docPath: d.document, headers, extras })
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faDownload}
                              style={{
                                width: "16px",
                                height: "16px",
                                marginRight: "9px",
                                color: "#5e5f60",
                              }}
                            />
                            Download
                          </Dropdown.Item>
                          <Dropdown.Item
                            href="#"
                            className="d-flex align-items-center"
                            onClick={() => {
                              if (!docGrant?.isDelete) {
                                toast.warning("You are not authorized for this action!")
                                return
                              }
                              onDelete(d.id)
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                              style={{
                                width: "16px",
                                height: "16px",
                                marginRight: "9px",
                                color: "#5e5f60",
                              }}
                            />
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ position: "absolute", left: `${moduleType?.toLowerCase() === "company" ? "16%" : "24%"}` }}
              >
                <img
                  src={nodata}
                  alt=""
                  style={{ width: "15rem", marginTop: "0" }}
                />
              </div>
            )
            :
            <UnauthViewModal tabName={"Documents"} />
        }
      </div >


      {/* Modal */}
      < Modal
        show={showModal}
        onHide={() => !submitLoading && setShowModal(false)}
        centered
        backdrop={submitLoading ? "static" : true}
        keyboard={!submitLoading}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ textTransform: "capitalize" }}>
            Add {moduleName} Document
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data" className="form-container">
            {/* Document Name */}
            <Form.Group className="mb-3 focus-z-index position-relative" controlId="formName">
              <Form.Label>Document Name <span className="text-danger">*</span> </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter document name"
                {...register("name")}
                isInvalid={!!errors.name}
                disabled={submitLoading}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name?.message}
              </Form.Control.Feedback>
            </Form.Group>

            {/* File Upload (PDF Only) */}
            <Form.Group className="mb-3 focus-z-index position-relative mt-1 " controlId="formFile">
              {/* <Form.Label style={{ marginBottom: 1}} className="border border-3 w-100">Upload File <span className="text-danger">*</span></Form.Label> */}
              <Form.Control
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                {...register("file")}
                isInvalid={!!errors.file}
                disabled={submitLoading}
              />
              <p
                style={{
                  color: "#a5a5a5",
                  fontSize: "11px",
                  fontWeight: 400,
                }}
              >
                Accepted file types are .jpg, .png, .pdf, .jpeg,  max file size
                5MB
              </p>
              <Form.Control.Feedback type="invalid">
                {errors.file?.message}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Description */}
            <Form.Group className="mb-3 focus-z-index position-relative" controlId="formDescription">
              <Form.Label>Description <span className="text-danger">*</span></Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Write a short description..."
                {...register("description")}
                isInvalid={!!errors.description}
                disabled={submitLoading}
              />
              <Form.Control.Feedback type="invalid">
                {errors.description?.message}
              </Form.Control.Feedback>
            </Form.Group>
            <hr style={{ marginBottom: "10px" }} />
            {/* Action Buttons */}
            <div className="mb-2 d-flex justify-content-end gap-2">
              <Button
                variant="secondary"
                onClick={onClose}
                className="btn btn-default-outline btn-sm"
                disabled={submitLoading}
              >
                Cancel
              </Button>
              <Button type="submit" disabled={isFormSubmitting} className="btn btn-default btn-sm">
                {submitLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal >
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmedDelete}
        isLoading={loading}
        message={"Are you sure you want to permanently delete this document?"}
      />
    </ >
  );
};

export default DocumentsList;

